<template>
	<div class="incenters">
		<div style="">
			<Commonbtn v-if="qx.add" backgroundColor="#FFF" title="新增" fontSize="14px" @btnclick="add"
				:src="require('@/assets/icon/icon-add.png')">
			</Commonbtn>
			<Commonbtn v-if="qx.update" backgroundColor="#FFF" title="修改" fontSize="14px" @btnclick="edit"
				:src="require('@/assets/icon/icon-update.png')">
			</Commonbtn>
			<Commonbtn v-if="qx.del" backgroundColor="#FFF" title="删除" fontSize="14px" @btnclick="del"
				:src="require('@/assets/icon/icon-del.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="exportData"
				:src="require('@/assets/channel/export.png')">
			</Commonbtn>
			<Commonbtn v-if="qx.add" backgroundColor="#FFF" title="导入" fontSize="14px" @btnclick="importData"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<a v-if="qx.import" class="Dowload" style @click="downloadTemplate">导入模板下载</a>
		</div>
		<div style="height: 10px;"></div>
		<div class="from">
			<Commontable ref="comtable" :tableData="tableData" :headerData="headerData" :hasChecked="false"
				@handleSelectionChange="handleSelectionChange" @onRowClick="onRowClick">
			</Commontable>
		</div>
		<div class="pagination">
			<Pagination :total="total" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
			</Pagination>
		</div>

		<!-- Add Dialog -->
		<DialogFrom width="800px" title="新增平台业务分析调整" :dialogVisible="dialogVisibleAdd" @cancel="cancelAdd"
			@dialogOK="dialogOKAdd">
			<div class="from">
				<template v-for="(item, index) of fromdataadd">
					<Commondropdownlist ref="addref" :inputdata="item.inputdata" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :lablewith="item.lablewith"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width" :options="item.options">
					</Commondropdownlist>
				</template>
			</div>
		</DialogFrom>

		<!-- Edit Dialog -->
		<DialogFrom width="800px" title="修改平台业务分析调整" :dialogVisible="dialogVisibleEdit" @cancel="cancelEdit"
			@dialogOK="dialogOKEdit">
			<div class="from">
				<template v-for="(item, index) of fromdataedit">
					<Commondropdownlist ref="editref" :inputdata="item.inputdata" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :lablewith="item.lablewith"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width" :options="item.options">
					</Commondropdownlist>
				</template>
			</div>
		</DialogFrom>

		<!-- Delete Confirm Dialog -->
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleDel" @cancel="cancelDel" @dialogOK="dialogOKDel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除选中的数据吗？</span>
		</Dialog>

		<!-- Import Dialog (Hidden Input) -->
		<input type="file" ref="fileInput" style="display: none" @change="handleFileChange" accept=".xlsx,.xls" />
	</div>
</template>

<script>
	import Commondropdownlist from "../../../../components/common-dropdownlist.vue";
	import Commontable from "../../../../components/common-table.vue";
	import Commonbtn from "../../../../components/common-btn.vue";
	import Pagination from "../../../../components/pagination.vue";
	import DialogFrom from "../../../../components/dialog-from.vue";
	import Dialog from "../../../../components/dialog.vue";
	import fromdataadd from "../fromData/add";
	import fromdataedit from "../fromData/edit";
	import utils from "../../../../common/utils";

	import {
		OrgStockMoneyChangeAdjustAdd,
		OrgStockMoneyChangeAdjustEdit,
		OrgStockMoneyChangeAdjustDelete,
		OrgStockMoneyChangeAdjustInfo,
		OrgStockMoneyChangeAdjustExport,
		OrgStockMoneyChangeAdjustDownloadTemplet,
		OrgStockMoneyChangeAdjustImport
	} from "@/api/OrgStockMoneyChangeAdjust";
	import {
		InventoryClassList
	} from '@/api/home';
	import {
		GetFirstOrganization
	} from '@/api/newsapi';

	export default {
		components: {
			Commontable,
			Commonbtn,
			Pagination,
			DialogFrom,
			Commondropdownlist,
			Dialog
		},
		props: {
			tableData: {
				type: Array,
				default: () => []
			},
			total: {
				type: Number,
				default: 0
			}
		},
		data() {
			return {
				qus: [],
				qx: {
					add: false,
					update: false,
					del: false,
					export: false,
					import: false,
					download: false
				},
				dialogVisibleAdd: false,
				dialogVisibleEdit: false,
				dialogVisibleDel: false,
				fromdataadd: [],
				fromdataedit: [],
				selection: [],
				currentRow: null,
				headerData: [{
						prop: 'selection',
						types: 'selection',
						fixed: 'left'
					},
					{
						prop: 'Year',
						label: '年度',
						columnwidth: 80
					},
					{
						prop: 'Month',
						label: '月份',
						columnwidth: 150
					},
					{
						prop: 'InvClassName',
						label: '产品线',
						columnwidth: 150
					},
					{
						prop: 'CompanyName',
						label: '平台',
						columnwidth: 200
					},
					{
						prop: 'Item',
						label: '项目',
						columnwidth: 200
					},
					{
						prop: 'Adjust',
						label: '调整值',
						columnwidth: 150
					},
					{
						prop: 'CreatorName',
						label: '创建人',
						columnwidth: 120
					},
					{
						prop: 'CreateTime',
						label: '创建时间',
					}
				],
				currentId: null
			};
		},
		mounted() {
			this.fromdataadd = JSON.parse(JSON.stringify(fromdataadd));
			this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit));
			this.QX();
		},
		methods: {
			QX() {
				let data = JSON.parse(localStorage.getItem("MenusData"));
				data.Menus[0].Nodes.map((item, index) => {
					if (item.NodeID == 33) {
						item.Nodes.map((items, indexs) => {
							if (items.NodeID == 1091) {
								this.qus = items.Nodes;
							}
						});
					}
				});
				if (this.qus) {
					this.qus.map((item, index) => {
						if (item.NodeName == "add") {
							this.qx.add = true;
						} else if (item.NodeName == "edit") {
							this.qx.update = true;
						} else if (item.NodeName == "delete") {
							this.qx.del = true;
						} else if (item.NodeName == "browse") {
							this.qx.browse = true;
						}
					});
				}
			},
			handleSelectionChange(val) {
				this.selection = val;
			},
			onRowClick(row) {
				this.currentRow = row;
			},
			handleCurrentChange(val) {
				this.currentRow = null;
				this.$emit('handleCurrentChange', val);
			},
			handleSizeChange(val) {
				this.currentRow = null;
				this.$emit('handleSizeChange', val);
			},
			async getOptions() {
				// Product Line
				let res1 = await InventoryClassList({});
				if (res1.code == 0) {
					let options = res1.data.data.map(item => ({
						key: item.InvClass,
						value: item.InvClassName
					}));
					this.fromdataadd[2].options = options;
					this.fromdataedit[2].options = options;
				}
				// Platform
				let res2 = await GetFirstOrganization({});
				if (res2.code == 0) {
					let options = res2.data.map(item => ({
						key: item.Value,
						value: item.Text
					}));
					this.fromdataadd[3].options = options;
					this.fromdataedit[3].options = options;
				}
			},
			add() {
				this.dialogVisibleAdd = true;
				this.getOptions();
				this.$nextTick(() => {
					// Reset form
					this.$refs.addref.forEach(item => item.modelvalue = '');
				});
			},
			cancelAdd() {
				this.dialogVisibleAdd = false;
			},
			async dialogOKAdd() {
				let data = {
					Year: this.$refs.addref[0].modelvalue,
					Month: this.$refs.addref[1].modelvalue,
					InvClass: this.$refs.addref[2].modelvalue,
					CompanyID: this.$refs.addref[3].modelvalue,
					Item: this.$refs.addref[4].modelvalue,
					Adjust: this.$refs.addref[5].modelvalue
				};
				// Validation could be added here
				let res = await OrgStockMoneyChangeAdjustAdd(data);
				if (res.code == 0) {
					this.$message.success('新增成功');
					this.dialogVisibleAdd = false;
					this.$emit('handleCurrentChange', 1);
				} else {
					this.$message.error(res.message);
				}
			},
			edit() {
				if (!this.currentRow) {
					this.$message.warning('请单击选择要修改的行');
					return;
				}
				this.currentId = this.currentRow.ID;
				this.dialogVisibleEdit = true;
				this.getOptions();
				this.getInfo(this.currentId);
			},
			async getInfo(id) {
				let res = await OrgStockMoneyChangeAdjustInfo({
					ID: id
				});
				if (res.code == 0) {
					let d = res.data;
					this.$nextTick(() => {
						this.$refs.editref[0].modelvalue = String(d.Year);
						this.$refs.editref[1].modelvalue = String(d.Month);
						this.$refs.editref[2].modelvalue = d.InvClass;
						this.$refs.editref[3].modelvalue = d.CompanyID;
						this.$refs.editref[4].modelvalue = d.Item;
						this.$refs.editref[5].modelvalue = d.Adjust;
					});
				}
			},
			cancelEdit() {
				this.dialogVisibleEdit = false;
			},
			async dialogOKEdit() {
				let data = {
					ID: this.currentId,
					Year: this.$refs.editref[0].modelvalue,
					Month: this.$refs.editref[1].modelvalue,
					InvClass: this.$refs.editref[2].modelvalue,
					CompanyID: this.$refs.editref[3].modelvalue,
					Item: this.$refs.editref[4].modelvalue,
					Adjust: this.$refs.editref[5].modelvalue
				};
				let res = await OrgStockMoneyChangeAdjustEdit(data);
				if (res.code == 0) {
					this.$message.success('修改成功');
					this.dialogVisibleEdit = false;
					this.currentRow = null;
					this.$emit('handleCurrentChange', 1);
				} else {
					this.$message.error(res.message);
				}
			},
			del() {
				if (this.selection.length === 0) {
					this.$message.warning('请选择要删除的数据');
					return;
				}
				this.dialogVisibleDel = true;
			},
			cancelDel() {
				this.dialogVisibleDel = false;
			},
			async dialogOKDel() {
				let ids = this.selection.map(item => item.ID);
				let res = await OrgStockMoneyChangeAdjustDelete({
					IDs: ids
				});
				if (res.code == 0) {
					this.$message.success('删除成功');
					this.dialogVisibleDel = false;
					this.currentRow = null;
					this.$emit('handleCurrentChange', 1);
				} else {
					this.$message.error(res.message);
				}
			},
			async exportData() {
				const loading = this.$loading({
					lock: true,
					text: '导出中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				this.$emit('Export');
				loading.close();
			},
			importData() {
				this.$refs.fileInput.click();
			},
			async handleFileChange(e) {
				const file = e.target.files[0];
				if (!file) return;
				const formData = new FormData();
				formData.append('file', file);

				const loading = this.$loading({
					lock: true,
					text: '导入中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				try {
					let res = await OrgStockMoneyChangeAdjustImport(formData);
					console.log(res)
					if (res.data && res.data.length > 0) {
						this.$alert(`${res.data.join('<br/>')}`, '提示', {
							dangerouslyUseHTMLString: true,
							showConfirmButton: false
						});
					} else {
						this.$message.success(res.message);
						this.$emit('handleCurrentChange', 1);
					}
				} catch (err) {
					this.$message.error('导入出错');
				} finally {
					loading.close();
					this.$refs.fileInput.value = ''; // Reset
				}
			},
			async downloadTemplate() {
				let res = await OrgStockMoneyChangeAdjustDownloadTemplet({});
				if (res.code === 0) {
					window.location.href = res.data;
				} else {
					this.$message.warning("下载失败");
				}
			}
		}
	};
</script>

<style lang="less" scoped>
	.incenters {
		height: 100%;

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 16px;
			padding-bottom: 16px;
		}

		.from {
			width: 100%;
		}
	}
</style>